module.exports = __webpack_public_path__ + "static/media/teygja_framanverdlaeri.aa874908.png";